const initialState = {
  user: {
    token: "",
    email: "",
    id: "",
    subscriptionLvl: "",
    username: "",
  },
  admin: {
    token: "",
    email: "",
    id: "",
    role: "",
    username: "",
  },
};

export const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case "ON_SET_USER_LOGIN":
      return {
        user: {
          token: action.payload.token,
          email: action.payload.email,
          id: action.payload.id,
          subscriptionLvl: action.payload.lvlSubscription,
          username: action.payload.username,
        },
        admin: initialState.admin,
      };
    case "ON_SET_ADMIN_LOGIN":
      return {
        user: initialState.user,
        admin: {
          token: action.payload.token,
          email: action.payload.email,
          id: action.payload.id,
          role: action.payload.role,
          username: action.payload.username,
        },
      };
    case "ON_SET_AUTH_LOGOUT":
      return initialState;
    default:
      return state;
  }
};
